import {combineReducers} from 'redux';
import Common from "./common";

const rootReducer = combineReducers({
    common: Common,
})

export default rootReducer;
